import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type RollerBlindsInstallationInfoData = {
  measurementUuid: string;
  constructionSiteUuids: Array<{ uuid: string; comment?: string }>;
  theBuildingIsMadeOf: 'ceramicBlock' | 'woodenStructure' | 'yTong' | 'silicate' | 'other';
  theBuildingIsMadeOfComment?: string;
  plannedInsulationThickness: string;
  typeOfInstallation: 'buildingWithFacade' | 'rawCondition';
  installationInWindowRecesses?: boolean;
  installationOnTheFacade?: boolean;
  rawConditionUuids?: Array<{ uuid: string; comment?: string }>;
  installationElementsUuids: Array<{ uuid: string; comment?: string }>;
  plannedAssemblyTime: string;
  numberOfAssemblyTeams: string;
};

const usePutRollerBlindsInstallationInfo = (
  options?: UseMutationOptions<any, Error, RollerBlindsInstallationInfoData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editRollerBlindsInstallationInfo'],
    mutationFn: async (data) => {
      return axiosInstance
        .put('/measurement/roller-blinds-and-blinds/installation-info', data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych instalacji rolet i żaluzji...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-roller-blinds-installation-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane instalacji rolet i żaluzji zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-roller-blinds-installation-info',
      });
      queryClient.invalidateQueries({ queryKey: ['rollerBlindsInstallationInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych instalacji rolet i żaluzji.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-roller-blinds-installation-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutRollerBlindsInstallationInfo;
